/** ひな形編集画面のエラーメッセージ定数 */
export const ERROR_MESSAGES = {
  TABLE_MOVE_TO_EMPLOYEE_CHECK: {
    title: '表を移動できません',
    message: '従業員チェック内に表を移動することはできません',
  },
  LOGIC_NEST_LIMIT: {
    title: '条件分岐の追加ができません',
  },
} as const
